import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {
  SalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/salary-dividend.options';
import {
  IncomeTaxPersonalInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/personal/income-tax-personal-in-salary-dividend.options';
import {
  IncomeTaxPersonalSpouseFederalInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/personal/income-tax-personal-spouse-federal-in-salary-dividend.options';
import {
  IncomeTaxPersonalSpouseInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/personal/income-tax-personal-spouse-in-salary-dividend.options';


@Component({
  selector: 'app-salary-dividend-personal-tax-spouse-form',
  templateUrl: './salary-dividend-personal-tax-spouse-form.component.html',
  styleUrls: ['./salary-dividend-personal-tax-spouse-form.component.scss'],
  standalone: false,
})
export class SalaryDividendPersonalTaxSpouseFormComponent {

  @Input()
  incomeTaxPersonalSpouseForm: AdvancedFormGroup<IncomeTaxPersonalSpouseInSalaryDividendOptions>;

  @Input()
  form: AdvancedForm<SalaryDividendOptions>;

  @Input()
  isSpouse: boolean;
  protected readonly AdvancedFormGroup = AdvancedFormGroup;

  constructor(private readonly translateService: TranslateService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get incomeTaxPersonalForm(): AdvancedFormGroup<IncomeTaxPersonalInSalaryDividendOptions> {
    return this.form.formElements.incomeTaxPersonalOptions as AdvancedFormGroup<IncomeTaxPersonalInSalaryDividendOptions>;
  }

  get federalForm(): AdvancedFormGroup<IncomeTaxPersonalSpouseFederalInSalaryDividendOptions> {
    return this.incomeTaxPersonalSpouseForm.formElements.federal as AdvancedFormGroup<IncomeTaxPersonalSpouseFederalInSalaryDividendOptions>;
  }

  refresh() {
  }
}
